<script setup lang="ts">
import { computed } from 'vue';
import { useAuthStore } from '@/stores/auth';
import MainLayout from '@/layouts/MainLayout.vue';

const authStore = useAuthStore();

const isAuthenticated = computed(() => authStore.isAuthenticated);
// Auth restoration is handled by the router guard in router/index.ts
</script>

<template>
  <MainLayout v-if="isAuthenticated">
    <RouterView />
  </MainLayout>
  <RouterView v-else />
</template>
